export default __webpack_public_path__ + "static/media/statesIcon.1ee68bc5.svg";